
export default class Alert {

	constructor(node) {
		this.node = node;
    this.init();
	}

	init() {
    const hasCookie = document.cookie.split(';').some((item) => item.trim().startsWith('alertClosed='));
    if(!hasCookie) {
      setTimeout(()=> {
        this.node.classList.add('active');
        this.addListeners();
      }, 800);
    }
	}

	addListeners() {
    const button = this.node.querySelector('[data-alert-close]');
    button.addEventListener('click', this.clickHandler.bind(this));
	}

  clickHandler() {
    this.node.classList.remove('active');
    this.setCookie();
    setTimeout(()=> {
      document.body.removeChild(this.node);
    }, 600);
  }

  setCookie() {
    const expirationDate = new Date();
    expirationDate.setDate(expirationDate.getDate() + 1); // 1 day
    document.cookie = 'alertClosed=true; expires=' + expirationDate.toUTCString() + '; path=/';
  }
}
